import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaxFormTable = _resolveComponent("TaxFormTable")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_TaxFormPng = _resolveComponent("TaxFormPng")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_row, {
    "no-gutters": "",
    class: "pa-1"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs_window_item, { value: "TaxFormTable" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "pa-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TaxFormTable, {
                            ref: "taxFormTable",
                            tables: _ctx.jsonForm,
                            values: _ctx.jsonValues,
                            rules: _ctx.jsonRules,
                            sheet: _ctx.sheet,
                            isLoaded: _ctx.loaded,
                            enableEdition: _ctx.enableEdition,
                            fieldsChild: _ctx.fieldsChild,
                            isSent: _ctx.isSent,
                            readOnly: _ctx.readOnly,
                            onUpdateSpecManager: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateSpecManager())),
                            onAdditionnalPageCreated: _ctx.additionnalPageCreated
                          }, null, 8, ["tables", "values", "rules", "sheet", "isLoaded", "enableEdition", "fieldsChild", "isSent", "readOnly", "onAdditionnalPageCreated"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_tabs_window_item, { value: "TaxFormPng" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        class: "px-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TaxFormPng, {
                            ref: "taxFormPng",
                            values: _ctx.jsonValues,
                            rules: _ctx.jsonRules,
                            cerfa: _ctx.jsonCerfa,
                            image: _ctx.imageForm,
                            isLoaded: _ctx.loaded,
                            enableEdition: _ctx.enableEdition,
                            sheet: _ctx.sheet,
                            fieldsChild: _ctx.fieldsChild,
                            readOnly: _ctx.readOnly,
                            onUpdateSpecManager: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSpecManager()))
                          }, null, 8, ["values", "rules", "cerfa", "image", "isLoaded", "enableEdition", "sheet", "fieldsChild", "readOnly"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}